/**
 * The MassEdit Operations of the Crop Rotation Grid
 */
export enum CropRotationOperations {
  CHANGE,
  REMOVE_SECOND_CROP,
  REMOVE_MAIN_CROP
}
